/**
 * Sidebar tab strip — History / Shared / Scheduled.
 * Re-skinned to use the design system Tabs primitive (segmented variant).
 */

import React from 'react';
import { Tabs } from './ui';

export type SidebarTab = 'history' | 'shared' | 'scheduled';

interface SidebarTabsProps {
  activeTab: SidebarTab;
  onTabChange: (tab: SidebarTab) => void;
  unreadCount: number;
}

const SidebarTabs: React.FC<SidebarTabsProps> = ({ activeTab, onTabChange, unreadCount }) => {
  const validUnreadCount =
    typeof unreadCount === 'number' && unreadCount >= 0 && !isNaN(unreadCount)
      ? unreadCount
      : 0;

  return (
    <div
      style={{
        padding: '0 1rem 1rem',
        borderBottom: '1px solid var(--border-subtle)',
      }}
      role="tablist"
      aria-label="Sidebar navigation"
    >
      <Tabs<SidebarTab>
        value={activeTab}
        onChange={onTabChange}
        size="md"
        fill
        ariaLabel="Sidebar navigation"
        options={[
          { value: 'history',   label: 'History' },
          { value: 'shared',    label: 'Shared', count: validUnreadCount > 0 ? Math.min(validUnreadCount, 99) : undefined },
          { value: 'scheduled', label: 'Scheduled' },
        ]}
      />
    </div>
  );
};

export default SidebarTabs;
